var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amap-container"},[_c('div',{ref:"mapRef",staticStyle:{"height":"100%"}}),_c('img',{staticClass:"refresh-img",attrs:{"src":require("@/assets/location/refresh.png")},on:{"click":_vm.handleRefresh}})])}
var staticRenderFns = []

export { render, staticRenderFns }